import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';
import SiteFooter from '../components/common/SiteFooter';

export default function VerifyEmail() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [state, setState] = useState('checking'); // checking | success | invalid
  // Verified, but the invited group could not be joined yet: the user retries from the invitation link
  const [inviteRetry, setInviteRetry] = useState(false);
  // Effects run twice in development; a second redemption of a single-use link would wrongly report it invalid
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.post('/api/users/verify-email', { token })
      .then((res) => {
        setInviteRetry(!!res.data.invitationPending);
        setState('success');
      })
      .catch(() => setState('invalid'));
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-md border border-gray-200 text-center">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">{t('verify.title')}</h2>
        {state === 'success' && <p className="text-green-600 mb-4">{t('verify.success')}</p>}
        {state === 'success' && inviteRetry && <p className="text-red-500 mb-4">{t('verify.inviteRetry')}</p>}
        {state === 'invalid' && <p className="text-red-500 mb-4">{t('verify.invalid')}</p>}
        {state !== 'checking' && (
          <Link to="/login" className="text-blue-600 underline">{t('verify.signIn')}</Link>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
